import { Box, Stack } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import bannerImage from 'src/asset/images/ai_hs_code_labeling/banner.png';
import ImageComponent from 'src/components/common/Image';
import WhiteBoxContent from 'src/components/common/WhiteBoxContent';
import { AI_HS_CODE_LABELING_TAB_KEY } from 'src/features/AIHSCodeLabeling/config';
import FormBulkUploadSearch from 'src/features/AIHSCodeLabeling/FormBulkUploadSearch';
import FormSingleSearch from 'src/features/AIHSCodeLabeling/FormSingleSearch';
import { useQueryParam } from 'src/hooks/useQueryParam';
import { SectionErrorBoundary } from 'src/components/ErrorBoundary/SectionErrorBoundary';

const AIHSCodeLabeling = () => {
  const [, setSearchParams] = useSearchParams();
  const selectedTab = useQueryParam('tab') ?? AI_HS_CODE_LABELING_TAB_KEY.single_search;

  const renderForm = () => {
    switch (selectedTab) {
      case AI_HS_CODE_LABELING_TAB_KEY.single_search:
        return <FormSingleSearch />;
      case AI_HS_CODE_LABELING_TAB_KEY.bulk_uploading_search:
        return <FormBulkUploadSearch />;
      default:
        return null;
    }
  };

  return (
    <WhiteBoxContent sx={{ boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10)' }}>
      {/* <Link to={AI_LABELING_URL_VIDEO} target="_blank">
        <Typography color={'primary.main'} textAlign={'center'} variant="caption">
          Learn more
        </Typography>
      </Link> */}
      <Stack flexWrap={'wrap'} mt={1} direction={'row'} gap={3}>
        <ImageComponent
          imgSrc={bannerImage}
          style={{
            maxWidth: 500,
          }}
        />
        <Box flex={1} px={3}>
          {/* <ToggleTab
            selected={selectedTab}
            handleChange={(_, tab) => {
              setSearchParams((params) => {
                params.set('tab', tab);
                return params;
              });
            }}
            tabs={AI_HS_CODE_LABELING_TABS}
          /> */}

          <SectionErrorBoundary resetKey={selectedTab} sectionName={selectedTab}>
            {renderForm()}
          </SectionErrorBoundary>
        </Box>
      </Stack>
    </WhiteBoxContent>
  );
};

export default AIHSCodeLabeling;
